var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "current-task-box" }, [
    _c("div", { staticClass: "font-weight-bold" }, [
      _vm._v(_vm._s(_vm._f("trans")("Current Task"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex gap-10px flex-column" }, [
      _c(
        "div",
        {
          staticClass: "current-task-btn",
          on: {
            click: function ($event) {
              return _vm.openLast()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center gap-10px h-100" },
            [
              _c(
                "div",
                { staticClass: "current-task-icon", class: _vm.redoIconOuter },
                [
                  _vm.svgIcon
                    ? _c("span", {
                        staticClass:
                          "icon-30 d-inline-flex flex-shrink-0 align-items-center justify-content-center rounded svg-white",
                        domProps: { innerHTML: _vm._s(_vm.redoIcon) },
                      })
                    : _c("i", {
                        staticClass: "far lh-inherit",
                        class: _vm.redoIcon,
                      }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "current-task-text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.currentJob.apiJob?.sat_links?.redo?.name) +
                    "\n        "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex gap-10px" },
        [
          _c("start-over-btn"),
          _vm._v(" "),
          _vm.currentJob.apiJob?.sat?.permissions?.can_continue === true
            ? _c("change-options-btn")
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "far fa-arrow-right" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }